export const VERSION_STATES = ['uploading', 'available', 'deleting', 'deleted', 'protected_unknown'] as const;
export const PROTECTION_REASONS = ['current_version', 'current_unavailable', 'coordination_unconfigured', 'operation_active', 'unknown_version', 'upload_incomplete', 'tombstoned', 'not_retired', 'clock_unavailable', 'retention_pending'] as const;
export type ProtectionReason = typeof PROTECTION_REASONS[number];
export interface VersionState {
  version: string;
  state: typeof VERSION_STATES[number];
  is_current: boolean;
  retirement: { replacement_version: string; retired_not_before: string | null } | null;
  retention_seconds: number;
  retention_eligible: boolean;
  protection_reason: ProtectionReason | null;
  deletion_enabled: boolean;
}
export const DELETION_STATUSES = ['queued', 'running', 'succeeded', 'failed', 'recovery_required'] as const;
export const DELETION_PHASES = ['queued', 'running', 'acquire_intent', 'acquire_intent_confirmed', 'tombstone', 'tombstone_confirmed', 'batch', 'batch_confirmed', 'deleted', 'deleted_confirmed', 'release_intent', 'release_intent_confirmed'] as const;
export interface DeletionJob {
  id: string;
  version: string;
  status: typeof DELETION_STATUSES[number];
  phase: typeof DELETION_PHASES[number];
  completed: number;
  batches: number;
  created_at: string;
  updated_at: string;
  error_code: 'deletion_failed' | 'deletion_uncertain' | null;
}
export interface DeletionRequest { version: string; key: string; id?: string }
export function canDeleteVersion(state: VersionState): boolean {
  return state.state === 'available' && !state.is_current && state.deletion_enabled && state.retention_eligible && state.protection_reason === null;
}
export function isDeletionActive(job: DeletionJob): boolean {
  return job.status === 'queued' || job.status === 'running';
}
